import { render, staticRenderFns } from "./SalePayment.vue?vue&type=template&id=61e71485&scoped=true&"
import script from "./SalePayment.vue?vue&type=script&lang=js&"
export * from "./SalePayment.vue?vue&type=script&lang=js&"
import style0 from "./SalePayment.vue?vue&type=style&index=0&id=61e71485&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e71485",
  null
  
)

export default component.exports